<template>
    <div class="width50 marketingHubPage__results--products cursor-pointer">
        <a
            class="marketingLinks results--product focus-inset flex flex-center"
            :href="matchMarketLink"
            :data-gtm="gtm">
            <!-- Market SVG -->
            <div class="margin-left-20">
                <svg
                    :class="iconClass"
                    viewBox="0 0 32 32"
                    width="32"
                    height="32"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true">
                    <circle
                        class="outlookClusterIcon__backgroundCircle"
                        cx="16"
                        cy="16"
                        r="16" />
                    <path
                        class="outlookClusterIcon__iconPath"
                        :d="svgIcon"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </div>
            <div class="flex flex--nowrap padding-right-20">
                <div>
                    <h2 class="marketingHubPage__results--market margin-bottom-5 text-color--dark-blue-gray">
                        {{ match.market }}
                    </h2>
                    <small class="resultsItem--product__small marketingHubPage__resultsHeader--topic">
                        {{ marketName }}
                    </small>
                </div>
            </div>
        </a>
    </div>
</template>
<script>
    import { getPath } from 'tools/getFromHtml';

    export default {
        props: {
            match: { type: Object, required: true },
            matchMarketLink: { type: String, required: true },
            gtm: { type: String, required: true },
            svgIcon: { type: String, required: true },
            marketName: { type: String, required: true },
            iconClass: { type: String, required: true },
        },
        data() {
            return {
                elementBaseClass: 'autocompleteList__results--svg',
                iconClassName: '',
                svgBaseClass: 'outlookClusterIcon outlookClusterIcon--',
                outlookBasePath: getPath('outlookHubPage'),
            };
        },
    };
</script>
